import React from "react";
import { Modal } from "@mui/material";
import { Close } from "@mui/icons-material";
import { useRecoilState } from "recoil";
import { useDeviceHook } from "../../utils/hooks/useDeviceHook";
import { Button } from "../shared/Button/Button";

import {
  FetalAddOnModalWrapper,
  DraftInfoModalMessage,
} from "../Grid/Grid.styles";
import {
  CFModalButtons,
  NewReqCFModalBody,
  NewReqCFModalTitle,
} from "./NewRequisition.styles";
import { currentNewRequisitionEdit } from "../../recoil/atoms";

const modalCenteringStyle = {
  alignItems: "center",
  justifyContent: "center",
  display: "flex",
} as const;

export const NewRequisitionCFModal: React.FC<{
  cfModalOpen?: boolean;
  setCFModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
}> = ({ cfModalOpen, setCFModalOpen }) => {
  const { deviceType } = useDeviceHook();

  const [, setNewRequisition] = useRecoilState(currentNewRequisitionEdit);

  const handleClose = () => {
    setCFModalOpen(false);
  };

  const handleConfirmOptOut = () => {
    setNewRequisition((current) => ({
      ...current,
      requisitionForm: {
        ...current.requisitionForm,
        cfDNAOptOut: true,
      },
    }));
    setCFModalOpen(false);
  };

  return (
    <Modal
      open={Boolean(cfModalOpen)}
      onClose={handleClose}
      style={modalCenteringStyle}
    >
      <FetalAddOnModalWrapper deviceType={deviceType}>
        <NewReqCFModalTitle>
          Are you sure you want to opt out of the fetal risk assay?
          <span onClick={handleClose}>
            <Close />
          </span>
        </NewReqCFModalTitle>
        <NewReqCFModalBody>
          <DraftInfoModalMessage>
            If opting out, a separate cfDNA assay will <span>NOT</span> be run
            if the patient is found to be a positive carrier.
          </DraftInfoModalMessage>
          <DraftInfoModalMessage>
            Are you sure you want to opt out of the fetal risk assay?
          </DraftInfoModalMessage>
        </NewReqCFModalBody>

        <CFModalButtons>
          <Button
            label="include fetal risk assessment"
            onClick={handleClose}
            size="small"
          />
        </CFModalButtons>
        <CFModalButtons>
          <Button
            label="continue to opt out"
            onClick={handleConfirmOptOut}
            size="small"
            className="opt-out"
          />
        </CFModalButtons>
      </FetalAddOnModalWrapper>
    </Modal>
  );
};
